import Vue, { PluginObject } from 'vue';
import VueRouter from 'vue-router';
import {Menu} from './views/menu';
import {SignIn} from './views/sign-in';
import {HomePage} from './views/home-page';
import {Redirect} from './views/redirect';
import {ChangePassword} from './views/change-password';
import {SetParticipant} from './views/set-participant';
import {Notifications} from './views/notifications';
import RouterAuthorisation from 'wc-lib/src/wc-authorisation/router-authorisation';

const RouterConfig = {
  routes: [
    { path: '/', component: SignIn, props: route => ({ externalAuth: route.query.externalAuth }) },
    { path: '/signin', component: SignIn,props: route => ({ externalAuth: route.query.externalAuth }) },
    { path: '/redirect', component: Redirect },
    { path: '/home', component: HomePage },
    { path: '/menu', component: Menu, meta: { auth: true } },
    { path: '/set-participant', component: SetParticipant, meta: { auth: true } },
    { path: '/notifications', component: Notifications, meta: { auth: true } },
    { path: '/change-password', component: ChangePassword }
  ]
};

const router = new VueRouter(RouterConfig);

// Fix router auth redirect to signin page, window.location hash change does not trigger 
// vue router push so manually forcing router push 
window.addEventListener("hashchange", () => {
  if (location.hash === '#/signin') {
    router.push('/signin');
  }
}, false);


Vue.use(RouterAuthorisation, { router: router });
Vue.use(VueRouter);

export default router;



// WEBPACK FOOTER //
// src/routes.ts